import {
  AppBar,
  Container,
  Drawer,
  Grid2,
  IconButton,
  Stack,
} from "@mui/material";
import { logo, logo2 } from "../assets/assets";
import RevealOnScroll from "./RevealOnScroll";
import { links, primaryColor, RedirectLink } from "../constants/constants";
import { Box } from "@mui/system";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useScreenSize from "../hooks/useScreenSize";
import useScrollHelper from "../hooks/useScrollHelper";

const Header = () => {
  const [openDrawer, setOpenDrawer] = useState(true);
  const { isLessThanMd } = useScreenSize();
  const [scrolled, setScrolled] = useState(false);

  const { pathname, hash } = useLocation();
  const { scrollToElementById, scrollToTop } = useScrollHelper();

  useEffect(() => {
    if (hash) {
      scrollToElementById(hash);
    } else {
      scrollToTop();
    }
  }, [pathname, hash]);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  useMemo(() => {
    handleCloseDrawer();
  }, [isLessThanMd]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <AppBar
      position={pathname !== RedirectLink.HOME ? "sticky" : "fixed"}
      sx={{
        background:
          pathname == RedirectLink.HOME && scrolled
            ? primaryColor
            : pathname != RedirectLink.HOME && scrolled
            ? primaryColor
            : "transparent",
        paddingTop: "10px",
        paddingBottom: "10px",
        boxShadow: scrolled ? "0 4px 10px rgba(0, 0, 0, 0.2)" : "none", // Add box-shadow when scrolled
      }}
    >
      <Grid2 container component={Container} maxWidth="xl">
        <Grid2 size={{ xs: 6, md: 2 }}>
          <RevealOnScroll effect="Zoom">
            <Link to={RedirectLink.HOME}>
              <img
                src={
                  pathname === RedirectLink.HOME ||
                  (pathname !== RedirectLink.HOME && scrolled)
                    ? logo
                    : logo2
                }
                width={150}
              />
            </Link>
          </RevealOnScroll>
        </Grid2>
        <Grid2 size={{ xs: 6, md: 10 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "100%",
            }}
          >
            {isLessThanMd ? (
              <IconButton
                size="large"
                sx={{
                  float: "right",
                  color:
                    pathname == RedirectLink.HOME || scrolled
                      ? "white"
                      : primaryColor,
                }}
                onClick={handleOpenDrawer}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <Stack direction="row" spacing={3.5}>
                {links.map((item) => {
                  return (
                    <Box sx={{ fontSize: "16px", fontWeight: 600 }}>
                      <Link
                        to={item.link}
                        style={{
                          color:
                            pathname == RedirectLink.HOME || scrolled
                              ? "white"
                              : pathname != RedirectLink.HOME && scrolled
                              ? "white"
                              : primaryColor,
                        }}
                      >
                        {item.title}
                      </Link>
                    </Box>
                  );
                })}
              </Stack>
            )}
          </Box>
        </Grid2>
      </Grid2>

      {isLessThanMd && (
        <Drawer anchor="right" open={openDrawer}>
          <Box
            sx={{
              width: "30vw",
              padding: "10px",
              textAlign: "right",
              display: "flex",
              flexDirection: "column",
              justifyContent: "right",
            }}
          >
            <IconButton
              size="large"
              color="inherit"
              sx={{ float: "right", maxWidth: "fit-content" }}
              onClick={handleCloseDrawer}
            >
              <CloseIcon />
            </IconButton>
            <Stack direction="column" spacing={2}>
              {links.map((item) => {
                return (
                  <Box
                    sx={{ fontSize: "16px", fontWeight: 600 }}
                    onClick={handleCloseDrawer}
                  >
                    <Link to={item.link}>{item.title}</Link>
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Drawer>
      )}
    </AppBar>
  );
};

export default Header;
